var _dec, _dec2, _class, _SideNavBarItem;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { testable } from '@instructure/ui-testable';
import { omitProps, getElementType } from '@instructure/ui-react-utils';
import { Tooltip } from '@instructure/ui-tooltip';
import { hasVisibleChildren } from '@instructure/ui-a11y-utils';
import { withStyle } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { allowedProps, propTypes } from './props';

/**
---
parent: SideNavBar
id: SideNavBar.Item
---
**/
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
let SideNavBarItem = (_dec = withStyle(generateStyle, generateComponentTheme), _dec2 = testable(), _dec(_class = _dec2(_class = (_SideNavBarItem = class SideNavBarItem extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props, {
      minimized: this.props.minimized
    });
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2, {
      minimized: this.props.minimized
    });
  }
  renderLink(addRef) {
    var _this$props$styles, _this$props$styles2, _this$props$styles3;
    const ElementType = getElementType(SideNavBarItem, this.props);
    const _this$props3 = this.props,
      href = _this$props3.href,
      onClick = _this$props3.onClick,
      icon = _this$props3.icon,
      label = _this$props3.label;
    const props = omitProps(this.props, SideNavBarItem.allowedProps);
    return _jsxs(ElementType, {
      ...props,
      href: href,
      onClick: onClick,
      ref: addRef ? this.handleRef : void 0,
      css: (_this$props$styles = this.props.styles) === null || _this$props$styles === void 0 ? void 0 : _this$props$styles.navigationItem,
      "aria-label": this.props.minimized ? label : void 0,
      children: [_jsx("div", {
        css: (_this$props$styles2 = this.props.styles) === null || _this$props$styles2 === void 0 ? void 0 : _this$props$styles2.icon,
        children: icon
      }), !this.props.minimized ? _jsx("div", {
        css: (_this$props$styles3 = this.props.styles) === null || _this$props$styles3 === void 0 ? void 0 : _this$props$styles3.label,
        children: label
      }) : null]
    });
  }
  render() {
    const _this$props4 = this.props,
      minimized = _this$props4.minimized,
      label = _this$props4.label;
    const hasTooltip = minimized && hasVisibleChildren(label);
    const link = this.renderLink(!hasTooltip);
    return hasTooltip ? _jsx(Tooltip, {
      renderTip: label,
      placement: "end",
      elementRef: this.handleRef,
      children: link
    }) : link;
  }
}, _SideNavBarItem.displayName = "SideNavBarItem", _SideNavBarItem.componentId = 'SideNavBar.Item', _SideNavBarItem.allowedProps = allowedProps, _SideNavBarItem.propTypes = propTypes, _SideNavBarItem.defaultProps = {
  as: 'a',
  selected: false,
  minimized: false
}, _SideNavBarItem)) || _class) || _class);
export default SideNavBarItem;
export { SideNavBarItem };